import React from 'react'
import styled from 'styled-components'
import Label from './Label'

const CheckboxWrapper = styled.div`
  cursor: pointer;
  display: grid;
  grid-template-columns: min-content auto 1fr;
  align-items: center;
`

const StyledCheckbox = styled.input.attrs({ type: 'checkbox' })`
  color: light-dark(inherit, var(--brand-grey-500));
  width: ${({ level }) => (level == 'sm' ? '18px' : '26px')};
  height: ${({ level }) => (level == 'sm' ? '18px' : '26px')};
`
const CheckboxLabel = styled(Label)`
  cursor: pointer;
  user-select: none;
  padding-left: var(--spacing-s);
`

const Checkbox = ({ beforeInput = null, id = 'checkbox', disabled = false, level = 'md', children, ...props }) => (
  <CheckboxWrapper>
    {beforeInput}
    <StyledCheckbox id={id} disabled={disabled} level={level} value={1} {...props} />
    <CheckboxLabel
      htmlFor={id}
      fontWeight="regular"
      color="light-dark(var(--brand-grey-400), var(--brand-grey-200))"
      disabled={disabled}
      level={level}
    >
      {children}
    </CheckboxLabel>
  </CheckboxWrapper>
)

export default Checkbox
